<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiPencilOutline } from "@mdi/js";
export default {
  name: "MdiPencilOutline",
  data() {
    return {
      svgPath: mdiPencilOutline,
    };
  },
};
</script>
